module.exports = __webpack_public_path__ + "static/media/room-11.31cec49a.jpeg";